import { Box, Text, Flex } from '@chakra-ui/react';
import { X } from 'lucide-react';

interface ModalShellProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  /** Pinned below the scroll area (e.g. primary action always visible). */
  footer?: React.ReactNode;
  /** Wider modals (e.g. task create/edit) */
  maxW?: string;
  maxH?: string;
}

export function ModalShell({
  open,
  onClose,
  title,
  children,
  footer,
  maxW = '500px',
  maxH = '80vh',
}: ModalShellProps) {
  if (!open) return null;

  return (
    <Box
      position="fixed"
      inset="0"
      bg="rgba(0,0,0,0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={1000}
      onClick={onClose}
    >
      <Box
        bg="volyx.bg"
        borderRadius="2xl"
        w="90%"
        maxW={maxW}
        maxH={maxH}
        display="flex"
        flexDirection="column"
        boxShadow="0 12px 48px rgba(0,0,0,0.15)"
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <Flex
          p="5"
          pb="4"
          justifyContent="space-between"
          alignItems="center"
          borderBottom="1px solid"
          borderColor="volyx.borderLight"
        >
          <Text fontSize="lg" fontWeight="bold" color="volyx.primary" m="0">
            {title}
          </Text>
          <Box
            as="button"
            bg="transparent"
            border="none"
            cursor="pointer"
            p="1"
            borderRadius="lg"
            _hover={{ bg: 'volyx.lightGray' }}
            onClick={onClose}
          >
            <X size={22} style={{ color: 'var(--chakra-colors-volyx-textSecondary)' }} />
          </Box>
        </Flex>
        <Box flex="1" minH="0" overflowY="auto" p="5">
          {children}
        </Box>
        {footer != null ? (
          <Box
            flexShrink={0}
            px="5"
            py="4"
            borderTop="1px solid"
            borderColor="volyx.borderLight"
            bg="volyx.bg"
          >
            {footer}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
